import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title';
import { getSamlResponse } from '../../actions/saml';
import { SAML_SERVICE_PROVIDER_CONSUME_URL } from '../../data/saml';

class SamlSso extends Component {
  form = null;

  setFormRef = element => {
    this.form = element;
  };

  submitForm = () => {
    if (this.form) {
      this.form.submit();
    }
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getSamlResponse());
  }

  componentDidUpdate(prevProps) {
    if (this.props.samlResponse !== prevProps.samlResponse) {
      this.submitForm();
    }
  }

  render() {
    const { samlResponse } = this.props;

    return (
      <Grid bsClass="container" fluid className="orders">
        <Row>
          <Col lg={12}>
            <PageTitle>eLearning</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            { samlResponse && (
              <form ref={this.setFormRef} method="post" action={SAML_SERVICE_PROVIDER_CONSUME_URL}>
                <input type="hidden" name="SAMLResponse" value={samlResponse} />
              </form>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    samlResponse: state.saml.samlResponse
  };
};

export default connect(mapStateToProps)(SamlSso);



// WEBPACK FOOTER //
// ./src/components/elearning/saml_sso.jsx